export default __webpack_public_path__ + "static/anyip-019750a09f4245665e3e143ff460750b.png";